import React, { useEffect, useMemo } from 'react';
import { SkuRedistributionResponse } from '@ydistri/api-sdk';
import { useSkuRedistributionTableColumns } from '../../Redistribution/parts/listing/components/SkuRedistributionTable/useSkuRedistributionTableColumns';
import { useCurrency } from '../../../../hooks/useCurrency';
import { computeRemSize } from '@ydistri/theme';
import { buildPickingPositionsStats } from './pickingPositionsStats';
import { ChangelogSectionProps, parseChangelogData } from '../editRedistributionLib';
import { DataTable } from '@ydistri/ds';

const ChangelogPickingPositions: React.FC<ChangelogSectionProps> = ({
  stringifiedData,
  onStatsComputed,
}) => {
  const columns = useSkuRedistributionTableColumns();
  const currency = useCurrency();

  const data = useMemo(
    () => parseChangelogData<SkuRedistributionResponse>(stringifiedData),
    [stringifiedData],
  );

  useEffect(() => {
    onStatsComputed(buildPickingPositionsStats(data, currency));
  }, [data, currency, onStatsComputed]);

  if (data.length === 0) return null;

  return (
    <DataTable<SkuRedistributionResponse>
      id="changelog-redistribution-picking-positions-table"
      showHeader={true}
      columns={columns}
      height={computeRemSize(400)}
      dataSource={data}
    />
  );
};

export default ChangelogPickingPositions;
